module.exports = __webpack_public_path__ + "img/confidence.1fb7aa92.svg";